import createIcon from '../../createIcon';

/**
 * @component @name Stream
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTRDMjEuMTA0NiAxNCAyMiAxMy4xMDQ2IDIyIDEyQzIyIDEwLjg5NTQgMjEuMTA0NiAxMCAyMCAxMEMxOC44OTU0IDEwIDE4IDEwLjg5NTQgMTggMTJDMTggMTMuMTA0NiAxOC44OTU0IDE0IDIwIDE0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQgMTRDNS4xMDQ1NyAxNCA2IDEzLjEwNDYgNiAxMkM2IDEwLjg5NTQgNS4xMDQ1NyAxMCA0IDEwQzIuODk1NDMgMTAgMiAxMC44OTU0IDIgMTJDMiAxMy4xMDQ2IDIuODk1NDMgMTQgNCAxNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiAyMkMxMy4xMDQ2IDIyIDE0IDIxLjEwNDYgMTQgMjBDMTQgMTguODk1NCAxMy4xMDQ2IDE4IDEyIDE4QzEwLjg5NTQgMTggMTAgMTguODk1NCAxMCAyMEMxMCAyMS4xMDQ2IDEwLjg5NTQgMjIgMTIgMjJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTAuMDUgOC41OUw2LjAzIDQuNTVINi4wMkw1LjcxIDQuMjNMNC4yOSA1LjY0TDguMzEgOS42OUw4LjMyIDkuNjhMOC42MyAxMEwxMC4wNSA4LjU5Wk0xMy45NDMgOC42MTdMMTguMzQ4IDQuMjI1TDE5Ljc2IDUuNjRMMTUuMzU1IDEwLjAzM0wxMy45NDMgOC42MTdaTTEwLjAxIDE1LjM2TDguNTkgMTMuOTVMNC41NiAxNy45Nkw0LjI0IDE4LjI5TDUuNjUgMTkuN0w5LjY4IDE1LjY4TDEwLjAxIDE1LjM2Wk0xOS43NiAxOC4zTDE1Ljc3IDE0LjI5TDE1LjQxIDEzLjk0TDE0IDE1LjM1TDE3Ljk5IDE5LjM2TDE4LjM0IDE5LjcxTDE5Ljc2IDE4LjNaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIgNkMxMy4xMDQ2IDYgMTQgNS4xMDQ1NyAxNCA0QzE0IDIuODk1NDMgMTMuMTA0NiAyIDEyIDJDMTAuODk1NCAyIDEwIDIuODk1NDMgMTAgNEMxMCA1LjEwNDU3IDEwLjg5NTQgNiAxMiA2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Stream = createIcon('Stream', [
  [
    'path',
    {
      d: 'M20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z',
      key: '3n6hjt',
    },
  ],
  [
    'path',
    {
      d: 'M4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14Z',
      key: 'ppd85e',
    },
  ],
  [
    'path',
    {
      d: 'M12 22C13.1046 22 14 21.1046 14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1046 10.8954 22 12 22Z',
      key: '78je59',
    },
  ],
  [
    'path',
    {
      d: 'M10.05 8.59L6.03 4.55H6.02L5.71 4.23L4.29 5.64L8.31 9.69L8.32 9.68L8.63 10L10.05 8.59ZM13.943 8.617L18.348 4.225L19.76 5.64L15.355 10.033L13.943 8.617ZM10.01 15.36L8.59 13.95L4.56 17.96L4.24 18.29L5.65 19.7L9.68 15.68L10.01 15.36ZM19.76 18.3L15.77 14.29L15.41 13.94L14 15.35L17.99 19.36L18.34 19.71L19.76 18.3Z',
      key: '14ndrz',
    },
  ],
  [
    'path',
    {
      d: 'M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z',
      key: '1cb55s',
    },
  ],
]);

export default Stream;
